import { createContext, useContext } from "react";
import type { Theme } from "@/lib/theme/type";

export const ThemeContext = createContext<{ theme: Theme } | null>(null);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
